import ApiManager from '../api/crud-manager';

class CatalogSearch {
  constructor(options = {}) {
    this.config = {
      modules: () => document.querySelectorAll('[data-module="CatalogSearch"]'),
      searchInput: el => el.querySelector('input'),
      suggestions: el => el.querySelector('.ac-suggestions'),
      apiManager: new ApiManager(),
      ...options
    };
  }

  init() {
    const { modules, searchInput, suggestions, apiManager } = this.config;

    if (!modules()) return;

    modules().forEach(module => {
      if (!searchInput(module)) return;

      const handleProductSelect = () => {
        window.dispatchEvent(
          new CustomEvent('OnProductSelect', {
            detail: {}
          })
        );
      };

      let timeout;
      let selectedKey = -1;

      searchInput(module).addEventListener('input', input => {
        clearTimeout(timeout);
        const inputValue = input.target.value;
        const regex = /^\s*$/;
        if (!regex.test(inputValue)) {
          timeout = setTimeout(() => {
            const url = `/api/v2/catalog/search/autocomplete?q=${inputValue}&category=/assortiment&template=CatalogSearch&omitfilterdata=true`;
            apiManager.get(url, 'text/html').then(response => {
              suggestions(module).innerHTML = '';
              suggestions(module).insertAdjacentHTML('beforeend', response);

              for (let i = 0; i < suggestions(module).childNodes.length; i += 1) {
                if (suggestions(module).childNodes[i].nodeName === '#text') {
                  suggestions(module).childNodes[i].remove();
                }
              }
              suggestions(module).classList.remove('hidden');
              suggestions(module).classList.add('open');
              suggestions(module)
                .querySelectorAll('.ac-suggest')
                .forEach(el => {
                  el.addEventListener('click', () => {
                    searchInput(module).value = el.dataset.value;
                    handleProductSelect();
                    suggestions(module).classList.add('hidden');
                  });
                });
            });
          }, 200);
        } else {
          suggestions(module).classList.add('hidden');
          selectedKey = -1;
        }
      });

      searchInput(module).addEventListener('keydown', e => {
        const key = window.event ? e.keyCode : e.which;
        if (key === 40 || key === 38) {
          const suggestOptions = suggestions(module).querySelectorAll('.ac-suggest');
          const selected = suggestions(module).querySelector('.ac-suggest.selected');

          if (selected) selected.classList.remove('selected');

          if (key === 40) {
            if (selectedKey + 1 > suggestOptions.length - 1) selectedKey = 0;
            else selectedKey += 1;
          } else if (key === 38) {
            if (selectedKey - 1 <= -1) selectedKey = suggestOptions.length - 1;
            else selectedKey -= 1;
          }

          const next = suggestOptions[selectedKey];
          next.classList.add('selected');
          searchInput(module).value = next.dataset.value;
          handleProductSelect();
        } else if (key === 27) {
          suggestions(module).classList.add('hidden');
          selectedKey = -1;
        } else if (key === 13) {
          e.preventDefault();
          let selected = suggestions(module).querySelector('.ac-suggest.selected');
          let inputValue = searchInput(module).value;
          if (selected) {
            inputValue = selected.dataset.value;
          } else {
            selected = suggestions(module).querySelector('.ac-suggest');
            if (selected) inputValue = selected.dataset.value;
          }

          searchInput(module).value = inputValue;
          handleProductSelect();
          suggestions(module).classList.add('hidden');
          selectedKey = -1;
        }
      });
    });
  }
}

export default CatalogSearch;
